export const getUsedPercentage = (used: number, total: number) => {
  if (total === 0) return 0
  return Math.round((used / total) * 100)
}
